import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { Box } from 'theme-ui'

const styles = {
  image: image => ({
    display: ['none', 'none', 'block', 'block'],
    height: `90%`,
    width: [0, 0, '1/3', '1/2'],
    //minWidth: 380,
    //maxHeight: 514,
    borderRadius: `none`,
    backgroundImage: `url(${image})`,
    backgroundRepeat: `no-repeat`,
    // filter: `grayscale(1)`,
    overflowX: `hidden`,
    position: `absolute`,
    bottom: '5%',
    right: 20,
    zIndex: 2
  })
}

export default () => {
  const data = useStaticQuery(conceptQuery)
  const { publicURL } = (data && data.file) || {}

  if (!publicURL) return ''

  return <Box sx={styles.image(publicURL)}></Box>
}

const conceptQuery = graphql`
  query ConceptQuery {
    file(absolutePath: { regex: "/shelf.(jpeg|jpg|gif|png)/" }) {
      publicURL
    }
  }
`
